import { defineStore } from "pinia";
import { ref } from "vue";

export const useControlStore = defineStore(
    "control",
    () => {
        const isDark = ref(false);
        const lang = ref(navigator.language.startsWith("es") ? "es" : "en");
        function toggleDark() {
            isDark.value = !isDark.value;
        }

        function changeLang(newLang: string) {
            lang.value = newLang;
        }

        return { isDark, toggleDark, lang, changeLang };
    },
    {
        persist: {
            key: "control"
        }
    }
);
